import { datadogRum } from '@datadog/browser-rum';
import { ButtonLink } from '@spark-web/button';
import { InformationCircleIcon } from '@spark-web/icon';
import { Inline } from '@spark-web/inline';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { CUSTOMER_PORTAL, getCustomerPortalUrl } from '../../utils';
import { ApplicationSubmissionStatus } from './types';

type CustomerPortalCardProps = {
  readonly applicationStatus: ApplicationSubmissionStatus;
};

function CustomerPortalCard({ applicationStatus }: CustomerPortalCardProps) {
  const handleClick = () => {
    datadogRum.addAction('customer_portal_handoff_started', { applicationStatus });
  };

  return (
    <Stack border="field" borderRadius="medium" padding="xxlarge" gap="large">
      <Inline gap="small" alignY="center">
        <InformationCircleIcon size="small" tone="info" />
        <Text size="large" weight="semibold">
          {CUSTOMER_PORTAL.HEADING}
        </Text>
      </Inline>
      <Text>{CUSTOMER_PORTAL.DESCRIPTION}</Text>
      <Stack align="center">
        <ButtonLink href={getCustomerPortalUrl()} onClick={handleClick} data={{ testId: 'go-to-customer-portal' }}>
          {CUSTOMER_PORTAL.GO_TO_CUSTOMER_PORTAL}
        </ButtonLink>
      </Stack>
    </Stack>
  );
}

export default CustomerPortalCard;
